import "@fortawesome/fontawesome-free/css/all.min.css";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.css";
import "./assets/css/customer/customerdashboard/customerLayout/customerdashboard.css";
import "./assets/css/general/fontStyles.css";
import Home from "./screens/customer/home/Home";

import HotelRoutes from "./Routes/HotelRoute/HotelRoutes";
import AdminLogin from "./screens/admin/adminAuth/AdminLogin";
import DestinationsDetail from "./subscreens/customer/PublicCustomerSubscreens/Destinations/DestinationDetail";
import CustomerDashboardLayout from './components/customer/CustomerDashboard/CustomerLayout/CustomerDashboardLayout';
import MainLayout from "./components/general/MainLayout";
import AdminDashboardRoutes from "./Routes/AdminRoutes/AdminDashboardRoutes";
import CustomerDashboardRoutes from './Routes/CustomerRoutes/CustomerDashboardRoutes';
import CustomerRegistration from "./screens/customer/CustomerForm/CustomerRegistration";
import BookingHotel from "./screens/customer/PublicCustomerScreens/BookingHotels/BookingHotel";
import FoodBlog from "./subscreens/customer/PublicCustomerSubscreens/FoodBlog/FoodBlog";
import HotelDetailsScreen from "./subscreens/customer/PublicCustomerSubscreens/HotelPages/HotelDetailsScreens";
import HotelsScreen from './subscreens/customer/PublicCustomerSubscreens/HotelPages/HotelsScreen';
// import Packages from "./subscreens/customer/PublicCustomerSubscreens/packages/Packages";
import Testimonial from "./subscreens/customer/PublicCustomerSubscreens/Tesimonial/TestimonialPage";
import FAQPage from "./screens/customer/PublicCustomerScreens/FAQs/FAQPage";
import AIPlanner from "./components/customer/CustomerDashboard/CustomerAiPlanner/AIPlanner";
import EventBlog from "./subscreens/customer/EventBlogs/EventBlog";
import CustomerTestimonials from "./screens/customer/CustomerTestimonials/CustomerTestimonials";
import PackagesScreen from "./screens/customer/CustomerPackages/Packagesscreen";
import TermsAndConditions from "./components/general/TermsAndConditions";
import PrivacyPolicy from "./components/general/PrivacyPolicy";
import PaymentSuccessScreen from "./components/customer/PublicCustomerScreens/PackagesComponent/PackageSuccessScreen";
import HotelSuccessScreen from "./components/customer/PublicCustomerScreens/BookingHotels/HotelSuccessScreen";
import NotFound from "./components/general/NotFound";
import ConnectionLost from "./components/general/ConnectionLost";
import TravelGuide from "./subscreens/customer/PublicCustomerSubscreens/HotelPages/Travel/TravelGuide";
function App() {
  return (
    <> 
      <Routes>
    
        {/* PUBLIC ROUTES */}
      <Route path="/admin/*" element={ <AdminDashboardRoutes />} />
         <Route path="/" element={<MainLayout><Home /></MainLayout>} />
         <Route path="/destinations" element={<MainLayout><DestinationsDetail /></MainLayout>} />
         <Route path="/customer-booking" element={<BookingHotel  />} />
         
         <Route path="/auth" element={<Navigate to="/auth/login" replace />} />
         <Route path="/auth/login" element={<CustomerRegistration />} />
         <Route path="/auth/signup" element={<CustomerRegistration />} />
         <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
         <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/hotel-payment-success" element={<HotelSuccessScreen />} />
         {/* PACKAGES ROUTES */}
        
<Route path="/packages"     element={<MainLayout><PackagesScreen /></MainLayout>} />
<Route path="/packages/:id" element={<PackagesScreen/>}/>

<Route path="/payment-success" element={<PaymentSuccessScreen />} />
        <Route path="/food-blogs" element={<MainLayout><FoodBlog /></MainLayout>} />
                <Route path="/testimonials" element={<MainLayout><Testimonial /></MainLayout>} />

      <Route path="/hotels" element={<MainLayout><HotelsScreen /></MainLayout>} />
      <Route path="/hotels/:id" element={<HotelDetailsScreen />} />
      <Route path="/faqs" element={<FAQPage />} />
      
        
        {/* ADMIN ROUTES */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/aiplanner" element={<MainLayout><AIPlanner /></MainLayout>} />
        {/* HOTEL ROUTES */}
        <Route path="/vendor/*" element={<HotelRoutes />} />

        {/* NEW Customer Dashboard with Layout and Routes */}
        <Route path="/customer/*" element={<CustomerDashboardLayout />}>
          {/* Nested routes inside layout */}
          <Route path="*" element={<CustomerDashboardRoutes />} />
        </Route>
        <Route path="/eventblogs" element={<MainLayout><EventBlog /></MainLayout>} />
        <Route path="/travelguide" element={<MainLayout><TravelGuide /></MainLayout>} />
        {/* Default redirect to home */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
        <Route path="*" element={<NotFound />} />
        <Route path="/connection-lost" element={<ConnectionLost />} />

        <Route path="/customertestimonials" element={<CustomerTestimonials />} />

      </Routes>
    </>
        
  );
}
export default App;